import clsx from 'clsx'
import Label from 'components/Luxkit/Label'
import React, { ComponentProps } from 'react'
import styled from 'styled-components'

const TierLabel = styled(Label)`
  &.kind-primary {
    &.tier-bronze {
      background-color: ${props => props.theme.palette.product.loyalty.bronze.darkBackground};
      color: ${props => props.theme.palette.product.loyalty.bronze.darkContrast};
      &.gradient {
        background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
        color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
      }
    }

    &.tier-silver {
      background-color: ${props => props.theme.palette.product.loyalty.silver.darkBackground};
      color: ${props => props.theme.palette.product.loyalty.silver.darkContrast};
      &.gradient {
        background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
        color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
      }
    }

    &.tier-gold {
      background-color: ${props => props.theme.palette.product.loyalty.gold.darkBackground};
      color: ${props => props.theme.palette.product.loyalty.gold.darkContrast};
      &.gradient {
        background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
        color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
      }
    }

    &.tier-platinum {
      background-color: ${props => props.theme.palette.product.loyalty.platinum.darkBackground};
      color: ${props => props.theme.palette.product.loyalty.platinum.darkContrast};
      &.gradient {
        background: ${props => props.theme.palette.product.loyalty.platinum.gradientPrimaryBackground};
        color: ${props => props.theme.palette.product.loyalty.platinum.darkContrast};
      }
    }
  }

  &.kind-secondary {
    &.tier-bronze {
      background-color: ${props => props.theme.palette.product.loyalty.bronze.normalBackground};
      border-color: ${props => props.theme.palette.product.loyalty.bronze.normalForeground};
      color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
    }

    &.tier-silver {
      background-color: ${props => props.theme.palette.product.loyalty.silver.normalBackground};
      border-color: ${props => props.theme.palette.product.loyalty.silver.normalForeground};
      color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
    }

    &.tier-gold {
      background-color: ${props => props.theme.palette.product.loyalty.gold.normalBackground};
      border-color: ${props => props.theme.palette.product.loyalty.gold.normalForeground};
      color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
    }

    &.tier-platinum {
      background-color: ${props => props.theme.palette.product.loyalty.platinum.normalBackground};
      border-color: ${props => props.theme.palette.product.loyalty.platinum.normalForeground};
      color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
    }
  }

  &.kind-tertiary {
    &.tier-bronze {
      background-color: ${props => props.theme.palette.product.loyalty.bronze.lightBackground};
      border-color: ${props => props.theme.palette.product.loyalty.bronze.lightBackground};
      color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
    }

    &.tier-silver {
      background-color: ${props => props.theme.palette.product.loyalty.silver.lightBackground};
      border-color: ${props => props.theme.palette.product.loyalty.silver.lightBackground};
      color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
    }

    &.tier-gold {
      background-color: ${props => props.theme.palette.product.loyalty.gold.lightBackground};
      border-color: ${props => props.theme.palette.product.loyalty.gold.lightBackground};
      color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
    }

    &.tier-platinum {
      background-color: ${props => props.theme.palette.product.loyalty.platinum.lightBackground};
      border-color: ${props => props.theme.palette.product.loyalty.platinum.lightBackground};
      color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
    }
  }
`

type InheritedLabelProps = Pick<ComponentProps<typeof Label>, 'children' | 'startIcon' | 'format'>

interface Props extends InheritedLabelProps {
  tier: App.LoyaltyTier;
  kind: 'primary' | 'secondary' | 'tertiary';
  gradient?: boolean
}

function LoyaltyTierLabel({ tier, kind, gradient, ...rest }: Props) {
  return <TierLabel
    {...rest}
    className={clsx(`tier-${tier}`, { gradient })}
    kind={kind}
    variant="grey"
  />
}

export default LoyaltyTierLabel
